export enum Pedigree {
  CP = 'CP',
  XXL = 'XXL',
  TP = 'TP',
  D = 'D',
  XP = 'XP',
}
